import type {
  WorkplaceRequestCategory,
  WorkplaceRequestUser
} from "@gettactic/api";

/** The parts of a category this helper needs. */
type AssigneeBearing = Pick<
  Partial<WorkplaceRequestCategory>,
  "default_assigned_users" | "office_assigned_users"
>;

/**
 * The users assignable to a request at a given office: the category's
 * office-specific members when it has any, otherwise its global default
 * members. Mirrors the admin assignment editor (`AssignmentTab`) so every
 * assignee picker agrees on who is eligible — including for viewers who can
 * only see their own category memberships, not the admin ticket-types list
 * `assigned_users` is normally read from.
 */
export const getCategoryAssignedUsers = (
  category: AssigneeBearing | undefined,
  officeId: string | undefined
): WorkplaceRequestUser[] => {
  const officeMembers =
    (officeId && category?.office_assigned_users?.[officeId]) || [];
  if (officeMembers.length > 0) {
    return officeMembers;
  }
  return category?.default_assigned_users ?? [];
};
